import { EntityDataStore } from '@skinsoft/entity-data-store';
import { first } from 'rxjs/operators';

export interface Item {
    id: string;
    identificationItemSchema: {
        barCodes: {
            translatedString: {
                fr: string;
            };
        };
    };
}

export class ItemDataStore extends EntityDataStore<Item> {
    public static getInstance() {
        if (!ItemDataStore.instance) {
            ItemDataStore.instance = new ItemDataStore();
        }

        return ItemDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$itemDataStore = ItemDataStore.getInstance();
    }

    private static instance: ItemDataStore = null as any;

    constructor() {
        super('items');
    }

    public exists(id: Item['id']) {
        return this.fetchOne(id)
            .pipe(first())
            .toPromise();
    }
}
